import { styled as styledMui, Box } from "@mui/material";

export const CardBox = styledMui(Box)<{
  selected?: boolean;
  disabled?: boolean;
}>(({ theme, selected, disabled }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  padding: "24px 20px",
  minHeight: "110px",
  borderRadius: "12px",
  backgroundColor: selected
    ? theme.palette.background.cardHover || "#323232"
    : "transparent",
  border: `1.5px solid ${
    selected ? theme.palette.primary.main : theme.palette.divider
  }`,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.4 : 1,
  textAlign: "center",
  transition: "background-color 0.15s ease, border-color 0.15s ease",
  "&:hover": disabled
    ? {}
    : {
        backgroundColor: theme.palette.background.cardHover || "#323232",
        borderColor: selected
          ? theme.palette.primary.main
          : theme.palette.divider,
      },
}));
